import { render, staticRenderFns } from "./AddNewProductComp.vue?vue&type=template&id=0ef781ae&scoped=true"
import script from "./AddNewProductComp.vue?vue&type=script&lang=js"
export * from "./AddNewProductComp.vue?vue&type=script&lang=js"
import style0 from "./AddNewProductComp.vue?vue&type=style&index=0&id=0ef781ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef781ae",
  null
  
)

export default component.exports